/**
 * Implements the role selector modal.
 */

import Radio from "backbone.radio";
import GenericModal from "../generic/modal/base";
import Form from "./form";

const channel = Radio.channel("global");

const DEFAULTS = {
  title: "Role Selector",
};

class RoleSelector extends GenericModal {
  constructor(options = {}) {
    _.defaults(options, DEFAULTS);
    super(options);
  }

  // @Override
  onRender() {
    this.body.show(
      new Form({
        // Retrieve current roles collection
        collection: channel.request("user:roles"),
      })
    );

    // call superclass
    if (super.onRender) super.onRender();
  }
}

export { RoleSelector as default };
